import { defineStore } from 'pinia';

type StoreStateType = {
	status_code?: string;
	temp_pay_pk?: string;
	pay_info_pk?: string;
	pay_token?: string;
	product_id?: string;
};
export const usePayInAppStore = defineStore('payInApp', {
	state: (): StoreStateType => {
		return {
			status_code: '',
			temp_pay_pk: '',
			pay_info_pk: '',
			pay_token: '',
			product_id: '',
		};
	},
	getters: {
		getStatusCode(state) {
			return state.status_code;
		},
		getTempPayPk(state) {
			return state.temp_pay_pk;
		},
		getPayInfoPk(state) {
			return state.pay_info_pk;
		},
		getPayToken(state) {
			return state.pay_token;
		},
		getProductId(state) {
			return state.product_id;
		},
	},
	actions: {
		setStatusCode(code: string) {
			this.status_code = code;
		},
		setTempPayPk(pk: string) {
			this.temp_pay_pk = pk;
		},
		setPayInfoPk(pk: string) {
			this.pay_info_pk = pk;
		},
		setPayToken(pk: string) {
			this.pay_token = pk;
		},
		setProductId(pk: string) {
			this.product_id = pk;
		},
		resetPayData() {
			this.$reset();
		},
	},
	persist: true,
});
